import { DynamicTextComponent } from '../../dynamic-text/dynamic-text-component';
import { BulletListItem } from '../types';

import styles from '../dynamic-bullet-list.module.scss';

export function getProsAndConsItems(selectedOffer: any): BulletListItem[] {
  if (!selectedOffer || !selectedOffer.structuredContentPros) return [];

  const extractChildrenByType = (offerData: any[], prefix: string) => {
    if (!Array.isArray(offerData)) return [];
    return offerData
      .map((item) => {
        if (
          item?.props?.children?.type === 'Type' &&
          item?.props?.children?.props?.children
        ) {
          return `[${prefix}] ${item?.props?.children?.props?.children}`;
        }
        return [];
      })
      .flat()
      .filter(Boolean);
  };

  const pros: string[] = extractChildrenByType(
    selectedOffer?.structuredContentPros || [],
    'pro'
  );
  const cons: string[] = extractChildrenByType(
    selectedOffer?.structuredContentCons || [],
    'con'
  );

  const prosAndConsItems: BulletListItem[] = [...pros, ...cons].map(
    (text, index) => ({
      id: `${index + 1}`,
      text,
    })
  );
  return prosAndConsItems;
}

function prosAndCons({
  items = [],
  listImageStyle,
  listItemsStyle,
  isMobile = false,
  fontProperties = { fontSize: 16 },
}: {
  items?: BulletListItem[];
  listImageStyle?: React.CSSProperties;
  listItemsStyle?: React.CSSProperties;
  isMobile?: boolean;
  fontProperties?: {
    fontSize: number;
    tablet?: {
      fontSize: number;
    };
    mobile?: {
      fontSize: number;
    };
  };
}) {
  return (
    <div
      className={styles.prosAndCons}
      style={{
        gridTemplateColumns: isMobile ? `auto` : `repeat(2, 1fr)`,
      }}
    >
      <div className={styles.pros}>
        <h3>Pros</h3>
        <ul style={{ ...listItemsStyle }}>
          {items
            .filter((item) => item.text?.toLowerCase().includes('[pro]'))
            .map((item: BulletListItem) => {
              const sanitizedItem = {
                ...item,
                text: item.text?.replace('[pro]', '').trim(),
                ...fontProperties,
              };
              return (
                <li style={listImageStyle} key={item.id}>
                  <DynamicTextComponent {...sanitizedItem} />
                </li>
              );
            })}
        </ul>
      </div>
      <div className={styles.cons}>
        <h3>Cons</h3>
        <ul style={{ ...listItemsStyle }}>
          {items
            .filter((item) => item.text?.toLowerCase().includes('[con]'))
            .map((item: BulletListItem) => {
              const sanitizedItem = {
                ...item,
                text: item.text?.replace('[con]', '').trim(),
                ...fontProperties,
              };
              return (
                <li style={listImageStyle} key={item.id}>
                  <DynamicTextComponent {...sanitizedItem} />
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}

export default prosAndCons;
